import { createRoutine } from 'redux-saga-routines';

export const stakeHvtRoutine = createRoutine('hirevibes/STAKE_HVT');
export const unStakeHvtRoutine = createRoutine('hirevibes/UNSTAKE_HVT');